module.exports = __webpack_public_path__ + "images/wheel-icon-xmas-7c1b61fe9178cd9a404ed47e481bbd3e.png";